export enum Language {
	EN = "EN",
	PT_BR = "PT_BR",
}
